"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInitialReducer = exports.injectReducer = exports.enhancer = exports.addReducer = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _redux = require("redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var existingDefinitions = [];
var store;

var makeRootReducer = function makeRootReducer(reducerDefinition) {
  var rootReducer = Object.entries(reducerDefinition).reduce(function (result, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value === 'function') {
      result[key] = value;
    }

    if (_typeof(value) === 'object') {
      result[key] = makeRootReducer(value);
    }

    return result;
  }, {});
  return (0, _redux.combineReducers)(rootReducer);
};

var addReducer = function addReducer(reducerDefinition) {
  if (!existingDefinitions.includes(reducerDefinition)) {
    existingDefinitions.push(reducerDefinition);
  }
};

exports.addReducer = addReducer;

var injectReducer = function injectReducer(reducerDefinition) {
  if (!existingDefinitions.includes(reducerDefinition)) {
    existingDefinitions.push(reducerDefinition);

    if (store) {
      var newDefinition = _deepmerge["default"].all(existingDefinitions);

      store.replaceReducer(makeRootReducer(newDefinition));
    }
  }
};

exports.injectReducer = injectReducer;

var makeInitialReducer = function makeInitialReducer(reducerDefinition) {
  existingDefinitions.push(reducerDefinition);

  var newDefinition = _deepmerge["default"].all(existingDefinitions);

  return makeRootReducer(newDefinition);
};

exports.makeInitialReducer = makeInitialReducer;

var enhancer = function enhancer(createStore) {
  return function (reducer, initialState, enhacer) {
    store = createStore(reducer, initialState, enhacer);
    store.injectReducer = injectReducer;
    return store;
  };
};

exports.enhancer = enhancer;